import z from 'zod';

export const editInventoryAmountEventSchema = z.object({
  amount: z.preprocess(
    (val) => {
      if (typeof val === 'string' && val.trim() !== '') {
        return Number(val);
      }
      if (typeof val === 'number') {
        return val;
      }
      return val;
    },
    z
      .number({
        required_error: 'Amount is required',
        invalid_type_error: 'Amount is required',
      })
      .min(0, 'Amount must be greater or equal to 0')
      .max(1000, 'Amount must be less than 1000')
  ),
});

export const productSetSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .max(50, 'Name cannot exceed 50 characters'),
  products: z
    .array(
      z.object({
        id: z.string().optional(),
        productId: z.string().min(1, 'Product is required'),
        size: z.string().min(1, 'Size is required'),
        amount: z.preprocess(
          (val) => {
            if (typeof val === 'string' && val.trim() !== '') {
              return Number(val);
            }
            return val;
          },
          z
            .number({
              required_error: 'Amount is required',
              invalid_type_error: 'Amount is required',
            })
            .int('Amount must be a whole number')
            .min(1, 'Amount must be at least 1')
        ),
      })
    )
    .min(1, 'At least one product is required')
    .superRefine((products, ctx) => {
      const seen = new Set<string>();

      products.forEach((product, index) => {
        if (!product.productId || !product.size) return;

        const key = `${product.productId}-${product.size}`;

        if (seen.has(key)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'This product and size is already in the set',
            path: [index, 'size'],
          });
        }

        seen.add(key);
      });
    }),
});

export type ProductSetFormValues = z.infer<typeof productSetSchema>;
